import { useMemo } from "react";
import { BtnEnviarGenerarExcel } from "../../../components/BtnObtenerExcel";
import Datatable from "../../../components/ui/datatable/Datatable";
import MonitorModal from "./MonitorModal";
import { useMonitor } from "./useMonitor";
import { BtnReenvio } from "./BtnReenvio";
import "../../../css/modal.css";

const renderBtnReenvioConfirmalo = (row, reenviarContrato) => (
  <BtnReenvio dato={row?.reenvio_contrato} id={row?.id} reenviarContrato={reenviarContrato} />
);

const getMonitorConfirmaloColumns = reenviarContrato => [
  { label: "Id envío", sortable: true, searchForColumn: true, key: "IdLote", selector: row => row.IdLote, headerAlign: "left", dataAlign: "left", width: "80px" },
  { label: "N° Personal", sortable: true, searchForColumn: true, key: "NPersonal", selector: row => row.NPersonal, headerAlign: "left", dataAlign: "left", width: "100px" },
  { label: "Nombre colaborador", sortable: true, searchForColumn: true, key: "Nombre", selector: row => row.Nombre, headerAlign: "left", dataAlign: "left", width: "200px" },
  { label: "RUT", sortable: true, searchForColumn: true, key: "Rut", selector: row => row.Rut, headerAlign: "left", dataAlign: "left", width: "120px" },
  { label: "División", sortable: true, searchForColumn: true, key: "Division", selector: row => row.Division, headerAlign: "left", dataAlign: "left", width: "150px" },
  { label: "Unidad organizativa", sortable: true, searchForColumn: true, key: "TextoUnidadOrganizativa", selector: row => row.TextoUnidadOrganizativa, headerAlign: "left", dataAlign: "left", width: "200px" },
  { label: "Subdivisión", sortable: true, searchForColumn: true, key: "Subdivision", selector: row => row.Subdivision, headerAlign: "left", dataAlign: "left", width: "150px" },
  { label: "Cargo", sortable: true, searchForColumn: true, key: "Cargo", selector: row => row.Cargo, headerAlign: "left", dataAlign: "left", width: "200px" },
  { label: "Fecha ingreso", sortable: true, searchForColumn: true, key: "FechaIngreso", selector: row => row.FechaIngreso?.replaceAll(".", "-"), headerAlign: "left", dataAlign: "left", width: "120px" },
  { label: "Emisión contrato", sortable: true, searchForColumn: true, key: "FechaEmisionContrato", selector: row => row.FechaEmisionContrato?.replaceAll(".", "-"), headerAlign: "left", dataAlign: "left", width: "140px" },
  { label: "ID Tramite", sortable: false, searchForColumn: false, key: "id_wf", selector: row => (row.id_wf ? row.id_wf : "---"), headerAlign: "left", dataAlign: "left", width: "130px" },
  { label: "% Avance", sortable: false, searchForColumn: false, key: "porcentaje_avance", selector: row => (row.porcentaje_avance != null ? row.porcentaje_avance : 0), headerAlign: "left", dataAlign: "left", width: "90px" },
  { label: "Recordatorio", sortable: true, searchForColumn: false, key: "reenvio_contrato", selector: row => renderBtnReenvioConfirmalo(row, reenviarContrato), headerAlign: "left", dataAlign: "center", width: "120px" },
];

const MonitorConfirmalo = () => {
  const { handleRowDoubleClick, showModal, setShowModal, selectedRow, reenviarContrato, fetchTableData } = useMonitor(2);
  const initialSortBy = "IdLote";
  const initialSortDir = "desc";

  // --- DEFINICIÓN DE COLUMNAS (MEMORIZADA) ---
  const columnsDef = useMemo(
    () => getMonitorConfirmaloColumns(reenviarContrato),
    [reenviarContrato],
  );

  return (
    <>
      {/* datatabla dinámico con los datos del monitor */}
      <Datatable storageKey="monitor-confirmalo-table" titletable="" requestDataFn={fetchTableData} initialPerPage={10} columns={columnsDef} orderColumns={true} adjustColumnSize={true} searchEnabled={true} searchColumnsEnabled={true} manualPageInput={true} onRowDoubleClick={handleRowDoubleClick} rowsPerPageOptions={[10, 20, 50, 100]} initialSortBy={initialSortBy} initialSortDir={initialSortDir} />

      {/* Boton para descargar excel */}
      <div className="row mt-3">
        <div className="col-sm-12">
          <BtnEnviarGenerarExcel ubicacionArchivo="excelMonitor/ReporteDataMonitorConfirmalo.xlsx" agregarFecha={true} />
        </div>
      </div>

      {/* Modal de detalles del registro */}
      <MonitorModal show={showModal} row={selectedRow} onClose={() => setShowModal(false)} />
    </>
  );
};

export default MonitorConfirmalo;
